// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../imageLarge.fragment.generated';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
import { VideoFragmentDoc } from '../video.fragment.generated';
export const ComponentVideoWithContentFragmentDoc = gql`
    fragment componentVideoWithContent on ComponentVideoWithContent {
  coverImage {
    ...imageLarge
  }
  content {
    ...contentComponentItem
  }
  video {
    ...video
  }
  videoPosition
}
    ${ImageLargeFragmentDoc}
${ContentComponentItemFragmentDoc}
${VideoFragmentDoc}`;